import classnames from 'classnames';
import { useRouter } from 'next/router';
import type { FunctionComponent } from 'react';

import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { usePageName } from '@/domains/productDiscovery/Listings/hooks/usePageName';
import { useRefine } from '@/domains/productDiscovery/Listings/hooks/useRefine';
import { useCategoryFamilyId } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryFamilyId';
import { useCategoryId } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryId';
import { useCategoryLevel } from '@/domains/productDiscovery/Listings/pages/Category/hooks/useCategoryLevel';
import { clearAllFilters } from '@/productDiscovery/Listings/components/Filters/utils/clearAllFilters';

import { translations } from '../../translations';

import styles from './ClearFiltersButton.module.scss';

export interface ClearFiltersProps {
  className?: string;
}

export const ClearFiltersButton: FunctionComponent<ClearFiltersProps> = ({
  className,
}) => {
  const pageName = usePageName();
  const refine = useRefine();
  const router = useRouter();
  const categoryId = useCategoryId();
  const categoryLevel = useCategoryLevel();
  const categoryFamilyId = useCategoryFamilyId();

  const onClearAllFilters = async () => {
    if (pageName) {
      clearAllFilters(pageName, router, refine);

      import(
        '@/domains/productDiscovery/Listings/components/Filters/tracking/generateFiltersTracking'
      ).then(({ trackResetFilters }) => {
        Gtm.push(
          trackResetFilters({
            category_id: categoryId,
            category_level: categoryLevel,
            family_id: categoryFamilyId,
          }),
        );
      });
    }
  };

  const rootClassnames = classnames(styles.root, className);
  return (
    <button
      type="button"
      className={rootClassnames}
      data-testid="clear-filters"
      onClick={onClearAllFilters}
    >
      {translations.reset}
    </button>
  );
};

ClearFiltersButton.displayName = 'ClearFiltersButton';
